import Component from '../core/Component'
import keycode from 'keycode'
import EventBus from '../core/EventBus'
import debounce from 'lodash/debounce'
import enquire from 'enquire.js'
import { queries } from '../core/config'
import { removeComponents } from '../core/componentUtils'

export const STATUS = {
    FOCUSED: 'is-focused',
    OPEN: 'is-open'
}

export const _defaults = {
    dynamic: false
}

export default class SearchForm extends Component {
    constructor(element) {
        super(element, _defaults)

        this.ref = {
            input: null
        }

        this.submit = debounce(::this.submit, 200)
        this.request = null
        this.isDesktop = false

        this.enquireHandler = {
            match: ::this.attach,
            unmatch: ::this.detach
        }
    }

    prepare() {
        this.ref.input.addEventListener('focus', ::this.handleFocus)
        this.ref.input.addEventListener('blur', :: this.handleBlur)

        if (this.options.dynamic) {
            // this.ref.input.addEventListener('change', :: this.handleKeyDown)
            this.ref.input.addEventListener('keydown', :: this.handleKeyDown)
        }

        enquire.register(queries.mediumUp, this.enquireHandler)
    }

    destroy() {
        enquire.unregister(queries.mediumUp, this.enquireHandler)
    }

    attach() {
        this.isDesktop = true
    }

    detach() {
        this.isDesktop = false
        if (this.request) {
            this.request.abort()
            this.request = null
        }

        const snippet = document.getElementById('snippet--searchAutocomplete')

        if (snippet) {
            removeComponents(snippet)
            snippet.innerHTML = ''
        }
    }

    handleKeyDown(event) {
        if (this.ref.input.value.length > 2) {
            this.submit(event)
        }
    }

    handleFocus() {
        this.element.classList.add(STATUS.FOCUSED)
    }

    handleBlur() {
        this.element.classList.remove(STATUS.FOCUSED)
    }

    submit(event) {
        if (!this.isDesktop) {
            return
        }

        if (this.previousValue !== this.ref.input.value) {
            this.previousValue = this.ref.input.value

            if (this.request) {
                this.request.abort()
            }

            this.request = $.nette.ajax({
                url: this.element.action,
                method: this.element.method || 'GET',
                dataType: 'JSON',
                data: $(this.element).serialize()
            })
        }
    }

    focus() {
        this.ref.input.focus()
    }

}